// generated by genversion
export var version = '5.0.10';
//# sourceMappingURL=version.js.map